import type { FC } from 'react'

import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  variant?: 'compact' | 'full'
}

export const BookingCardSkeleton: FC<Props> = ({ variant = 'compact' }) => (
  <Paper
    padding={[12]}
    radius="16px"
    className={clsx(s.card, {
      [s.compact]: variant === 'compact',
      [s.full]: variant === 'full',
    })}
  >
    <div className={s.content}>
      <div className={s.badges}>
        <span className={s.badge} />
        <span className={s.dateBadge} />
      </div>

      <div className={s.info}>
        <span className={s.titleLine} />
        <span className={s.detailsLine} />
        <span className={s.addressLine} />
      </div>
    </div>
  </Paper>
)
